export default __webpack_public_path__ + "static/media/industry.072da7bc.svg";